/** WhatsApp share via wa.me — opens WhatsApp with pre-composed text. */
export function whatsappShare(text) {
  const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
  window.open(url, "_blank", "noopener,noreferrer");
}

export function inspectionShareText({ lang, loomNumber, weaverName, poNumber, milestone, percent, grade, defects }) {
  const hi = lang === "hi";
  const lines = [
    hi ? "HAG कारपेट्स — निरीक्षण रिपोर्ट" : "HAG Carpets — Inspection Report",
    "",
    `${hi ? "लूम" : "Loom"}: ${loomNumber || "-"}`,
    `${hi ? "बुनकर" : "Weaver"}: ${weaverName || "-"}`,
    `PO: ${poNumber || "-"}`,
    `${hi ? "माइलस्टोन" : "Milestone"}: ${milestone}`,
    `${hi ? "% पूरा" : "% Complete"}: ${percent ?? "-"}%`,
    `${hi ? "ग्रेड" : "Grade"}: ${grade}`,
    `${hi ? "दोष" : "Defects"}: ${defects ?? 0}`,
    "",
    `${hi ? "लिंक" : "Link"}: ${window.location.href}`,
  ];
  return lines.join("\n");
}

export function routeSummaryShareText({ lang, inspectorName, date, looms }) {
  const hi = lang === "hi";
  const total = looms.length;
  const graded = looms.filter((l) => l.last_grade).length;
  const overdue = looms.filter((l) => l.overdue).length;
  const header = hi
    ? `HAG कारपेट्स — ${inspectorName} — ${date}`
    : `HAG Carpets — ${inspectorName} — ${date}`;
  const stats = hi
    ? `कुल लूम: ${total} · दौरे हुए: ${graded} · अतिदेय: ${overdue}`
    : `Total looms: ${total} · Visited today: ${graded} · Overdue: ${overdue}`;
  const list = looms
    .slice(0, 15)
    .map((l) => `• ${l.loom_number} (${l.weaver_name})${l.last_grade ? ` — ${l.last_grade}` : ""}`)
    .join("\n");
  return [header, "", stats, "", list].join("\n");
}
